module.exports = __webpack_public_path__ + "static/media/lens.3ae880d2.svg";